<template>
  <div
    class="modal fade"
    :class="{ in: isShowModal, active: isShow }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-show="isShow"
  >
    <div class="modal-bg" @click="onModalClose"></div>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div
          class="common-modal-close"
          data-dismiss="modal"
          aria-label="Close"
          @click="onModalClose"
        >
          <img
            class="common-modal-close"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
          />
        </div>

        <div class="modal-body">
          <div class="booking_rule_hd">
            新冠防护隐私政策
          </div>
          <div class="booking_rule_bd">
            <div class="billofrights_text ps-container">
              <p><strong>1. 重点</strong></p>
              <p>
                <strong>1.1 您的隐私事宜。</strong
                >我们希望您能了解我们如何使用您提供给我们的个人信息。
              </p>
              <p>
                <strong>1.2 我们收集和处理与您有关的信息。</strong
                >为应对目前新型冠状病毒肺炎（Covid-19）对健康所造成的威胁，我们已经采取了新的措施，以强化我们的常规业务运营模式。通过这些新的措施，我们会收集和处理您的个人信息，包括一些与您健康状况有关的个人敏感信息。这会帮助我们确保所有船上人员的健康和安全，包括您和您的旅行同伴、我们的员工以及其他诸如服务提供商的第三方。部分措施也能协助政府当局控制病毒的扩散。
              </p>
              <p>
                <strong>1.3 无法律义务。</strong
                >我们特此告知您，并且您确认知悉，在某些管辖地域，搜集该等个人信息对于我们所提供的服务而言是强制性要求，旨在应对目前新冠病毒（Covid-19）对健康造成的威胁。而在其他管辖地域，您并无法律义务向我们提供该等个人信息，但若未能提供该等个人信息，您将无法乘坐我们的游轮并享受我们的服务。
              </p>
              <p>&nbsp;</p>
              <p><strong>2. 谁为本隐私政策提及的您的个人信息负责？</strong></p>
              <p>
                2.1
                本隐私政策（&ldquo;政策&rdquo;）中提及的&ldquo;我们&rdquo;或&ldquo;我们的&rdquo;，是指负责处理本政策所提及的个人信息的数据控制方。数据控制方可以按如下方式确定：
              </p>
              <p>
                (a)
                受制于如下第2.1（c）款，如果您乘坐的是我们皇家或精钻会游轮，则是Royal
                Caribbean Cruises Ltd.,
                地址位于弗罗里达迈阿密加勒比大道1050号（&ldquo;皇家&rdquo;）；
              </p>
              <p>
                (b)
                受制于如下第2.1（c）款，如果您乘坐的是我们名人游轮，则是Celebrity
                Cruises Inc.,
                地址位于弗罗里达迈阿密加勒比大道1050号（&ldquo;名人&rdquo;）；
              </p>
              <p>
                (c) 如果您乘坐的是RCL Cruises
                Ltd.或其在欧洲经济区或英国的实体组织的游轮巡游，则是RCL Cruises
                Ltd.，地址位于Building 3, The Heights, Brooklands, Weybridge,
                Surrey KT13 0NY, UK.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong
                  >3.
                  健康检查和措施：我们收集哪些个人信息以及我们如何使用这些信息</strong
                >
              </p>
              <p>
                <strong>3.1 健康问卷和健康筛查。 </strong
                >在您航行前，我们可能会收集有关您的年龄、病历（包括疫苗接种具体信息）和当前健康状况的一些信息，以确认您的健康状况适合游轮旅行，以及尽可能识别Covid-19症状。我们会分阶段地收集这些信息以确保它是准确的和最新的。我们从您那里收集信息，我们依赖您的诚信。我们可能会在您购买船票时、或者通过在线值船或应用程序（当您在船上发现自己有任何Covid-19症状时可以使用该应用程序）收集您的信息。于港口在您登船前，我们可能会询问一些有关您健康状况的额外问题，我们也可能会要求您进行健康检查以及/或者提供有关您的健康状况的材料，所有这些都是为了确保您的健康状况适合旅行。在停靠港口离船及/或登船时，以及在您航程结束离船时，我们可能会重复进行一些或全部的健康筛查措施。
              </p>
              <p>
                <strong>3.2 体温测量。</strong>
                我们可能会在您登船前测量您的体温，并且可能会在您登船后一天一次测量您的体温，同时，您进入船上设施时也需要测量体温。我们可能也会在您在停靠港口登船及/或离船时测量您的体温。这可能会要求您自行通过体温扫描仪或者由我们的员工或服务提供商使用体温计为您测量。这是为了尽可能地识别Covid-19症状。
              </p>
              <p>
                <strong>3.3 Covid-19检测。</strong
                >您可能会被要求做检测以判断您是否感染Covid-19或者您是否已经从感染的Covid-19中恢复。我们可能要求您在家检测、在检测中心检测，和/或我们可能要求您在登船前在港口检测。我们也可能在您登船后要求您进行检测。我们必须再次强调，这些检测的目的是为了判断哪些人感染或者曾经感染Covid-19以努力防止病毒的扩散，也是为了遵守适用法律法规的规定。我们或相关政府部门可能会要求您在航次结束后进行Covid-19检测。我们可能会按照政府部门和健康服务提供商的要求向其提供必要的医疗数据（包括个人可识别内容）。
              </p>
              <p>
                <strong>3.4 拍照、摄像及其他记录。</strong
                >您在船上及登船、离船过程中，我们会对您进行拍照、摄像并记录其他有关您的信息。
              </p>
              <p>
                <strong>3.5 接触者追踪：可穿戴设备。</strong>
                我们可能会要求您参与我们的接触者追踪计划，期间您可能需要全程佩戴一个可穿戴设备。这个设备能够识别在航行过程中与您有过密切接触的其他人的设备号，以及关于您在船上所处位置的大致信息。&ldquo;密切接触&rdquo;是指在15分钟或更长时间内，与他人的相互间距离不超过2米或6英尺。如果有人汇报了Covid-19症状，我们可能会通过分析我们持有的信息，帮助我们识别出所有在船上与症状者有过密切接触的其他人，包括使用下述第3.6款所述流程。我们就可以请我们识别出来的密切接触者采取适当的措施，包括监测他们的健康状况、在一段时间内留在客房、和/或在必要情况下，到医疗区进行适当的检查或检测。我们从可穿戴设备所收集的信息将仅用于防止传染病传播之目的。我们可能会将可穿戴设备搜集到的匿名化信息与政府部门分享，以使其了解船上不同区域客人的互动模式。我们可能会请您选择一个强化版的产品，它既能代替可穿戴设备，也能作为船卡使用。该强化产品会收集额外的个人信息，更多详情会在您使用它前提供给您。
              </p>
              <p>
                <strong>3.6 接触者追踪：识别和减缓信息。</strong>
                当我们发现疑似感染者时，我们可能也会使用我们系统中的个人信息来识别密切接触者。如上，&ldquo;密切接触&rdquo;是指在15分钟或更长时间内，与他人的相互间距离不超过2米或6英尺。这个系统会使用有关您何时去过船上何处的信息。我们会在船上的系统中记录这些信息，比如，当您在咖啡厅使用船卡购买饮品时，又比如，当您到客服柜台咨询时，以及当您在某个特色餐厅用餐时。如果有人汇报了Covid-19症状，我们可能会通过分析我们持有的信息，帮助我们识别出所有在船上与症状者有过密切接触的其他人。我们就可以请我们识别出来的密切接触者采取适当的措施，包括监测他们的健康状况、在一段时间内留在客房、和/或在必要情况下，到医疗区进行适当的检查或检测。
              </p>
              <p>
                <strong>3.7 CCTV监控。</strong>
                我们为安全保障之目的（如寻找走丢的人员）在船上使用CCTV监控，而现在我们也可能会用CCTV监控进行接触者追踪。我们还会使用升级软件通过人脸识别和工具分析CCTV录像，以识别个性化特征，如某个人衣服的颜色。我们使用这些系统里的信息以了解乘客在船上的流动情况，了解船上哪些区域人员最为密集（比如，哪些区域乘客可能更难保持社交距离），哪些区域人们会更经常地脱下口罩。这将帮助我们确保我们的健康航行措施是在充分了解情况基础上不时更新的。
              </p>
              <p>&nbsp;</p>
              <p><strong>4. 处理您个人信息的法律依据</strong></p>
              <p>
                4.1
                我们基于您的同意处理您的个人信息。您同意我们按照本隐私政策处理您的个人信息是您进行游轮行程的前提条件。
              </p>
              <p>
                4.2
                同时，我们根据本政策规定处理您的个人信息，是为了履行我们的法律义务；因为这对保护我们的乘客、船员和服务提供商的切身利益是至关重要的，是预防性卫生保健和职业医学这一目标所必须的，并且是公共卫生领域为保护公众利益所必要的，包括预防严重的跨境健康威胁以及确保卫生保健的高品质和安全标准。
              </p>
              <p>&nbsp;</p>
              <p><strong>5. 我们会和谁分享您的个人信息</strong></p>
              <p>
                5.1
                我们可能会根据需要把您的个人信息分享给您的出发地和目的地国家的第三方。这些第三方包括：
              </p>
              <p>(a) 政府机关，特别是港口主管机关；</p>
              <p>(b) 卫生主管机关；</p>
              <p>(c) 医疗保健提供商。</p>
              <p>
                请注意，我们与这些第三方所分享的信息可能包括我们通过健康检查所搜集的信息，包括测试结果。特定第三方，如卫生主管机关，可能会就该等信息与您取得联系。
              </p>
              <p>
                5.2
                为了便于游轮旅行，我们也可能会在皇家加勒比集团内部、与我们的业务合作伙伴以及那些协助我们提供、管理和执行本政策所述流程的第三方服务提供商（包括诸如码头代理和岸上游运营商，帮助我们在船上及/或码头提供检测服务的服务商等）分享您的个人信息。
              </p>
              <p>&nbsp;</p>
              <p><strong>6. 我们保存个人信息的期限</strong></p>
              <p>
                6.1
                我们通常仅会尽可能短时间地保存该等与Covid-19有关的个人信息，除非特定国家适用法律要求我们更长时间地保存该等信息，或者行程中发生了Covid-19相关的事件导致需要更长时间地保存该等信息。
              </p>
              <p>&nbsp;</p>
              <p><strong>7. 您的权利</strong></p>
              <p>
                7.1
                请知悉，就我们所持有的关于您的个人信息，您享有各种权利，包括选择不接收直接营销信息的权利、要求查看或审阅我们所持有的您的个人信息的权利、要求更新或纠正信息的权利、要求删除信息的权利，另有限制或管控要求的除外。
              </p>
              <p>&nbsp;</p>
              <p><strong>8. 您的信息的转移</strong></p>
              <p>
                8.1
                我们可能会管理、储存、处理、保管或转移个人信息至您所在管辖地以外的世界其他地方（包括通过云服务提供商），而该等地方的隐私法律可能没有您所在管辖地那么严格。通过预订游轮，您即同意我们使用、处理、管理、储存、以及/或者转移您的个人信息至您所在管辖地以外的其他国家或地区。请注意，我们搜集的很多个人信息都是在美国进行处理的。若对信息的转移有任何特定的法律法规规定，我们将确保客人信息按照该等法律要求进行个人信息的保护和转移。
              </p>
              <p>&nbsp;</p>
              <p><strong>9. 更多信息</strong></p>
              <p>
                9.1
                如果您对本隐私政策提及的有关个人信息的使用有任何问题，您可以通过ChinaPrivacy@rcclapac.com联系我们。
              </p>
              <p>
                9.2
                有关个人信息使用的更多信息，可查看我们的隐私政策，该政策发布在我们的公司网站，也可查看<a
                  href="https://www.rcclchina.com.cn/Rccl.UserCenter/Privacy"
                  >https://www.rcclchina.com.cn/Rccl.UserCenter/Privacy</a
                >。
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingPrivacyPopup",
  props: {
    isShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowModal: false,
    };
  },
  methods: {
    onModalClose() {
      this.isShowModal = false;
      setTimeout(() => {
        this.$emit("onModalClose");
      }, 100);
    },
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  padding: 20px;
}
.modal-dialog {
  top: 15%;
}
.booking_rule_hd {
  font-size: 22px;
  color: #282b2c;
  margin-bottom: 20px;
  font-weight: bold;
}

.booking_rule_bd {
  max-height: 500px;
  overflow: scroll;
  > p {
    margin-bottom: 6px;
  }
	ol {
    padding-left: 20px;
  }
  ul,
  li {
    list-style: initial;
  }
  ol {
    li {
      list-style-type: decimal;
    }
  }

  ul {
    li {
      list-style-type: circle;
    }
  }

  li {
    margin-bottom: 10px;
  }
}

.modal {
  .common-modal-close {
    position: absolute;
    width: 28px;
    top: 3px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
  }
}

.modal.active {
  display: block;
  overflow-x: hidden;
  overflow-y: scroll;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.leftPoint{
  padding-left: 30px;
}
</style>